<template>
  <!-- 仅根据 -->
  <div class="ClassSelection">
    <!-- 原 开始 -->
    <div class="class-head ClassSelection-header">
      <div class="plan-selector">
        <div @click="showArrangPlan = true">
          <span v-cloak>{{ arrangPlan.name || arrangPlan }}</span>
          <i class="iconfont">&#xe620;</i>
        </div>
        <div @click="showPlanName = true">
          <span v-cloak class="nowarp">{{ planName.name || planName }}</span>
          <i class="iconfont">&#xe620;</i>
        </div>
      </div>
      <ul style="margin: 50px 0" v-show="arrangPlan.value === 2">
        <li
          v-for="(item, index) in week"
          :key="index"
          :class="type === index ? 'active_tab' : ''"
          @click="changeTab(index)"
        >
          <p v-cloak>
            {{ item.Name }}
          </p>
        </li>
      </ul>
      <div class="radius" v-show="arrangPlan.value === 2 && cloumns.length > 0" />
    </div>
    <!-- 排课方案 -->
    <van-action-sheet
      v-model="showArrangPlan"
      :actions="arrangPlanList"
      cancel-text="取消"
      @select="ChangeArrangPlan"
    />
    <!-- 方案名称 -->
    <van-action-sheet
      v-model="showPlanName"
      :actions="planNameList"
      cancel-text="取消"
      @select="GetTable"
    />
    <!-- -------------------具体的课程表------------------------ -->
    <!-- 先排 -->

    <div class="class_info" v-if="arrangPlan.value === 2">
      <ul v-if="cloumns.length > 0">
        <li v-for="(item, index) in cloumns" :key="index">
          <img src="@/assets/homeSchool/clock-roundness-gray@2x.png" alt v-if="index === 0" />
          <img v-else src="@/assets/homeSchool/clock-roundness-blue@2x.png" alt />
          <span v-cloak>{{ item.AMorPMOrderName }}</span>
          <p
            v-cloak
            :style="{ color: bg[index % 5].color, background: bg[index % 5].background }"
            @click="showDetail(item)"
          >
            {{
              item.SubjectName
                ? item.SubjectName.slice(0, item.SubjectName.length - 1)
                : item.SubjectName
            }}
          </p>
        </li>
      </ul>
      <div v-else class="xy-phone-no-data">
        <img src="@/assets/basic/moblie-no-data.png" />
        <p>暂无选课结果</p>
      </div>
    </div>
    <!-- 先 选 -->
    <div class="class-content" v-if="arrangPlan.value === 3">
      <div class="class-content-title van-hairline--bottom">
        选课结果
      </div>
      <div class="class-content-list" v-if="list.length > 0">
        <div
          class="class-content-info van-hairline--bottom"
          v-for="(i, index) in list"
          slot="list"
          :key="index"
        >
          <img :src="subjectIcon" alt />
          <p v-cloak>
            {{ i.SubjectName }}
          </p>
          <p v-cloak>已选：{{ i.SelectCount }}人</p>
        </div>
      </div>
      <div v-else class="xy-phone-no-data">
        <img src="@/assets/basic/moblie-no-data.png" />
        <p>暂无选课结果</p>
      </div>
    </div>
    <div v-else-if="arrangPlan === '请选择排课方案'" class="xy-phone-no-data">
      <img src="@/assets/basic/moblie-no-data.png" />
      <p style="padding-top:20px;color:#7f7f7f;">
        暂无选课结果
      </p>
    </div>

    <!-- 原 结束 -->
  </div>
</template>

<script>
import { Dialog } from 'vant'
/*
 *  本文件仅从原项目复制并简易调整而来，包括HTML、JS、CSS
 *  原作者：李原，王丹
 *  迁移自：2019-10-22 版本，宋培英修改
 *  合并版本：2019-11-9 版本， 李坤修改
 */
export default {
  name: 'ClassSelection',
  data() {
    return {
      StudentID: '',
      arrangPlan: '请选择排课方案',
      planName: '请选择方案名称',
      progress1: 0.1,
      showArrangPlan: false,
      showPlanName: false,
      arrangPlanList: [
        // { name: '先排后选', value: 2},
        { name: '先选后排', value: 3 }
      ], //排课方案
      planNameList: [], //方案名称
      childInfo: {},
      list: [],
      sectionList: [
        '1节',
        '2节',
        '3节',
        '4节',
        '5节',
        '6节',
        '7节',
        '8节',
        '9节',
        '10节',
        '11节',
        '12节'
      ],
      zaoData: ['早1', '早2'],
      wanData: ['晚1', '晚2', '晚3', '晚4'],
      week: [], //周时间
      cloumns: [], //每天有多少节课
      type: 0,
      reslutData: [], //一周上课时间结构
      allSubjectName: [], //一周上课所有课程
      bg: [
        { background: 'rgba(52,121,205,0.1)', color: 'rgba(38, 100, 209, 1)' },
        { background: 'rgba(237,250,238,1)', color: 'rgba(9,175,24,1)' },
        { background: 'rgba(88,72,237,0.1)', color: 'rgba(88,72,237,1)' },
        { background: 'rgba(242,155,42,0.2)', color: 'rgba(242,155,42,1)' },
        { background: 'rgba(255,240,236,1)', color: 'rgba(248,52,1,1)' },
        { background: 'rgba(88,72,237,1)', color: 'rgba(159,6,235,1)' }
      ],
      subjectIcon: require('@/assets/homeSchool/hexagon-book-green@2x.png')
    }
  },
  computed: {
    apiPath() {
      return this.$store.state.apiPath
    },
    childData() {
      return this.$store.state.parentInfo.childData
    }
  },
  methods: {
    changeTab(val) {
      this.type = val
      var that = this
      this.getWeekClass(this.reslutData)
      that.allSubjectName.forEach(item => {
        if (item.Day === that.type && that.cloumns.length > 0) {
          that.cloumns.forEach((ins, index) => {
            if (ins.AMorPM === item.AMorPM && ins.AMorPMOrder === item.AMorPMOrder) {
              ins.SubjectName += item.SubjectName + '/'
              that.$set(that.cloumns, index, ins)
            }
          })
        }
      })
    },

    // 改变课名称 如：am 1改为早1
    getWeekClass(val) {
      var arr = ['一', '二', '三', '四', '五', '六', '日']
      var that = this
      that.cloumns = []
      that.week = []
      val.map((item, index) => {
        item.map((ins, index2) => {
          if (index === 0) {
            that.week.push({
              Name: '周' + arr[ins.Day]
              // Day: ins.Day
            })
          }
          if (index2 === that.type) {
            if (ins.AMorPM === 'MS') {
              ins.AMorPMOrderName = that.zaoData[ins.Order]
            }
            if (ins.AMorPM === 'AB') {
              // ins.AMorPMOrderName = '上午大课间'
            }
            if (ins.AMorPM === 'PB') {
              // ins.AMorPMOrderName = '下午大课间'
            }
            if (ins.AMorPM === 'NS') {
              // ins.AMorPMOrderName = '午休'
            }
            if (ins.AMorPM === 'ES') {
              ins.AMorPMOrderName = that.wanData[ins.Order]
            }
            if (ins.AMorPM === 'AM' || ins.AMorPM === 'PM') {
              ins.AMorPMOrderName = that.sectionList[ins.Order]
            }
            if (ins.AMorPMOrderName) {
              ins.SubjectName = ''
              that.cloumns.push(ins)
            }
          }
        })
        // console.log(that.cloumns, that.week)
      })
    },

    //改变排课方案
    async ChangeArrangPlan(val) {
      this.arrangPlan = val
      this.showArrangPlan = false
      //获取方案名称
      this.xy.loading()
      this.planNameList = []
      let params = {
        StudentID: this.StudentID,
        ClassTableType: this.arrangPlan.value
      }
      let res = await this.xyapi.get(
        this.apiPath + '/api/StudentOnLineSelectCourse/GetSelectCourseClassShiftByID',
        params
      )
      if (res.success) {
        if (res.data.length > 0) {
          var courseClass = res.data
          this.planName = {
            name: courseClass[0].ClassTableName,
            value: courseClass[0].ClassTableID
          }
          courseClass.forEach(item => {
            this.planNameList.push({
              name: item.ClassTableName,
              value: item.ClassTableID
              // callback: value => {
              //   this.planName = value;
              //   this.GetTable();
              // }
            })
          })
          this.GetTable()
        } else {
          this.planName = '请选择方案名称'
        }
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },

    //获取选课结果
    async GetTable(sVal) {
      this.showPlanName = false
      if (sVal) {
        this.planName = sVal
      }
      this.type = 0
      this.xy.loading()
      this.list = []
      //先选
      if (this.arrangPlan.value === 3) {
        let params = {
          classTableID: this.planName.value,
          StudentID: this.StudentID
        }
        let res = await this.xyapi.get(
          this.apiPath + '/api/StudentOnLineSelectCourse/GetMovingClassResultList',
          params
        )
        if (res.success) {
          if (res.data) {
            res.data.List.forEach(val => {
              val.Subjects.forEach(item => {
                if (item.DetailID > 0) {
                  this.list.push({
                    SubjectName: item.SubjectName,
                    SelectCount: item.SelectCount
                  })
                }
              })
            })
          }
        } else {
          this.xy.msgError(res.msg)
        }
        this.xy.unloading()
      }
      //先排
      else if (this.arrangPlan.value === 2) {
        this.cloumns = []
        this.GetClassTableTimeAll()
      }
    },
    // 获取周课时间结构
    async GetClassTableTimeAll() {
      let params = {
        classTableID: this.planName.value
      }
      let res = await this.xyapi.get(
        this.apiPath + `/api/ClassTableTime/GetClassTableTimeAll`,
        params
      )
      if (res.data.success) {
        if (res.data.data.length > 0) {
          var val = res.data.data
          this.reslutData = val
          this.getWeekClass(this.reslutData) //重新改变周数据时间结构
          this.getSubject() //获取一周所有的课程
        }
      } else {
        this.xy.msgError(res.msg)
      }
    },
    // 获取一周所有的课程表
    async getSubject() {
      let params = {
        classTableID: this.planName.value,
        StudentID: this.StudentID
      }
      let res = await this.xyapi.get(
        this.apiPath + `/api/StudentOnLineSelectCourse/PackageOnLineResultList`,
        params
      )
      if (res.data.success) {
        if (res.data.data) {
          // var ResultsVal = res.data.data.Results;
          this.allSubjectName = res.data.data.Results
          this.allSubjectName.forEach(item => {
            if (item.Day === this.type && this.cloumns.length > 0) {
              this.cloumns.forEach((ins, index) => {
                if (ins.AMorPM === item.AMorPM && ins.AMorPMOrder === item.AMorPMOrder) {
                  ins.SubjectName += item.SubjectName + '/'
                }
                this.$set(this.cloumns, index, ins)
              })
            }
          })
        }
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    showDetail(item) {
      if (item.SubjectName) {
        Dialog.alert({
          message: item.SubjectName.slice(0, item.SubjectName.length - 1)
        })
      }
    }
  },
  created: function() {
    this.StudentID = this.childData.ChildrenID
    this.$store.commit('changeNavBg', true)
  },
  beforeDestroy: function() {
    this.$store.commit('changeNavBg', false)
  }
}
</script>

<style lang="less" scoped>
/* 头部背景设置：将整个容器设置为绝对定位 */
.ClassSelection {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  &-header {
    height: 260px;
    padding-top: 145px;
    background: url('~@/assets/homeSchool/roundBar-blue@2x.png') no-repeat 0 / cover;
  }
}

// 扩展菜单高度，使其能够完整显示（将成为多行）
::v-deep .van-action-sheet__item {
  height: auto;
  min-height: 50px;
}
</style>

<style lang="less" scoped>
/* 此部分仅将原CSS通过less组织，并稍加调整 */
.plan-selector {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 60px;
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 320px;
    height: 60px;
    border-radius: 30px;
    background: rgba(0, 0, 0, 0.15);
    padding: 16px 30px;
    font-size: 28px;
    color: #fff;
    & > i {
      font-size: 18px;
    }
  }
}

.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 84%;
}

.active_tab {
  /* opacity: 1 !important; */
  background: rgba(249, 249, 249, 1) !important;
  & > p:first-child {
    font-weight: bold;
    color: rgba(7, 0, 97, 1) !important;
  }
  & > p:last-child {
    font-weight: bold;
    color: #9d97bd !important;
  }
}

.radius {
  width: 100%;
  padding: 30px 20px;
  background: rgba(249, 249, 249);
  border-radius: 66px 66px 0 0;
  position: absolute;
  bottom: 0;
}

.class-content {
  background: rgba(249, 249, 249);
  &-title {
    color: #1d2157;
    font-size: 28px;
    font-weight: bold;
    padding: 25px 50px;
  }
  &-list {
    padding: 0 50px;
  }
  &-info {
    height: 134px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & img {
      width: 58px;
      height: 64px;
    }
    & > p:nth-of-type(1) {
      flex-grow: 1;
      margin-left: 30px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(4, 4, 4, 1);
      line-height: 30px;
    }
    & > p:nth-of-type(2) {
      font-size: 22px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 30px;
    }
  }
}

.class-content-info .content-choose {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}

.content-choose > div {
  display: flex;
  justify-content: space-between;
}

/* 具体的课程表 */
.class_info {
  width: 100%;
  margin-top: 450px;
  padding: 20px 20px;
  background: rgba(249, 249, 249);
  & > ul {
    border-left: 1px dashed #b6baca;
    margin-left: 16px;
    & > li {
      display: flex;
      margin-bottom: 60px;
      padding: 20px 30px;
      align-items: center;
      padding-left: 0;
      position: relative;
      height: 100px;
      & > img {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 0px;
        top: 0px;
        transform: translate(-50%);
      }
      & > span {
        position: absolute;
        z-index: 1;
        left: 40px;
        display: block;
        top: 100px;
        font-size: 28px;
      }
      & > p {
        min-height: 100px;
        width: 80%;

        border-radius: 14px;
        font-size: 26px;
        font-weight: bold;

        position: absolute;
        z-index: 1;
        left: 120px;
        display: block;
        top: -100px;
        padding: 30px 0 30px 30px;
      }

      &:last-child:before {
        content: '';
        width: 4px;
        height: 100%;
        background-color: rgba(249, 249, 249, 1);
        position: absolute;
        left: -3px;
      }
    }
  }
}
</style>
